<script setup lang="ts">
import { CircleAlert, CircleCheck, Info, X } from 'lucide-vue-next'
import { useToast, type ToastType } from '@/composables/useToast'

const { toasts, dismiss } = useToast()

const typeClass: Record<ToastType, string> = {
  success: 'sh-success',
  error: 'sh-error',
  info: 'sh-info',
}

const typeIcon = {
  success: CircleCheck,
  error: CircleAlert,
  info: Info,
}
</script>

<template>
  <Teleport to="body">
    <div class="pointer-events-none fixed bottom-[1em] right-[1em] z-[30000] flex w-[clamp(260px,22em,90vw)] flex-col gap-[0.5em]">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toasts"
          :key="toast.id"
          class="pointer-events-auto sh-glass p-[0.25em] cursor-pointer"
          role="status"
          @click="dismiss(toast.id)"
        >
          <div :class="typeClass[toast.type]" class="!m-0 flex items-start gap-[0.55em] text-[0.88em]">
            <component :is="typeIcon[toast.type]" :size="17" class="mt-[0.1em] shrink-0" />
            <span class="flex-1 leading-[1.4]">{{ toast.message }}</span>
            <button
              type="button"
              class="shrink-0 rounded-[0.3em] p-[0.1em] transition-colors hover:bg-sh-raise-3"
              aria-label="Schließen"
              @click.stop="dismiss(toast.id)"
            >
              <X :size="14" class="text-sh-text-muted" />
            </button>
          </div>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(0.8em);
}

.toast-move {
  transition: transform 0.25s ease;
}
</style>
